import type { ProductCategoryProductCategoryReadModel } from '@r/api/generated/client.schemas.ts';

type ProductCategory = ProductCategoryProductCategoryReadModel;

/**
 * Détermine les IDs de catégories à envoyer à l'API selon les filtres actifs.
 * Une sous-catégorie est prioritaire ; sinon on envoie les enfants d'une catégorie ou son propre ID.
 */
export const getProductCategoriesToFetch = (
  subcategoryId: string | undefined,
  categoryId: string | undefined,
  productCategories: ProductCategory[]
): string[] => {
  if (subcategoryId) {
    return [subcategoryId];
  }

  if (categoryId && productCategories.length > 0) {
    const parentCategory = productCategories.find((cat) => String(cat.id) === categoryId);
    if (!parentCategory) return [];

    const childCategoryIds = parentCategory?.childs?.map((child) => String(child.id)) || [];
    return childCategoryIds.length > 0 ? childCategoryIds : [categoryId];
  }

  return [];
};

/**
 * Lit les IDs de marques sélectionnées depuis les paramètres d'URL (`brandIds`).
 * Accepte une chaîne séparée par des virgules, un tableau ou une valeur unique.
 */
export const parseBrandIdsFromSearch = (value: unknown): number[] => {
  if (value == null || value === '') return [];

  if (Array.isArray(value)) {
    return value.map((id) => Number(id)).filter((id) => !Number.isNaN(id));
  }

  if (typeof value === 'string') {
    return value
      .split(',')
      .map((id) => Number(id.trim()))
      .filter((id) => !Number.isNaN(id));
  }

  if (typeof value === 'number' && !Number.isNaN(value)) {
    return [value];
  }

  return [];
};

/**
 * Sérialise les IDs de marques pour les persister dans l'URL.
 * Retourne `undefined` lorsqu'aucune marque n'est sélectionnée.
 */
export const formatBrandIdsForSearch = (brandIds: number[]): string | undefined => {
  if (brandIds.length === 0) return undefined;
  return brandIds.join(',');
};
